export default "__VITE_ASSET__B5Q3$wot__"